import { mutationTypes, actionTypes } from 'BASE/store/types'
import signalr from 'BASE/common/signalrAdapter'
import CONSTANT from 'BASE/common/chat/chat.constant'
import { browser } from 'BASE/common/util/util.browser';

class ChatMessageLossDetection {
    constructor() {
        this.intervalTime = 60 * 1000;
        this.isStop = true;
        this.vue = undefined;
    }

    start(vue) {
        if (!browser.isMobile) {
            return;
        }
        if (!this.isStop) {
            return;
        }

        this.isStop = false;
        this.vue = vue;
        this.check();
    }

    stop() {
        this.isStop = true;
    }

    async check() {
        if (this.isStop) {
            return;
        } else if (!this.vue) {
            return;
        }
        
        if (this.vue.$store.state.chat.isConnected) {
            try {
                let roomWindows = this.vue.$store.state.chat.roomWindows;
                for (let i = 0; i < roomWindows.length; i++) {
                    let window = roomWindows[i];
                    // 目前只做客服聊天室
                    if (window.room.type === CONSTANT.roomType.CUSTOMER_SERVICE) {
                        let roomId = window.room.id;
                        let clearTime = window.room.messageClearTime;
                        let result = await signalr.chatServer.getHistoryMessageCount({
                            RoomId: roomId, 
                            StartTime: clearTime,
                        });
                        let code = result.Code;
                        let serverCount = result.Count;
                        let serverStartTimeStr =  result.StartTime;
                        if (code === CONSTANT.code.SUCCESS) {
                            let serverStartTime = new Date(serverStartTimeStr);
                            await this.checkMessageCount(roomId, serverStartTime, serverCount);
                        }
                        break;
                    }
                }
            } catch (error) {
                console.error("send signalr failed, error=" + error);
            }
        }

        setTimeout(() => this.check(), this.intervalTime);
    }
    
    async checkMessageCount(roomId, startTime, serverCount) {
        let container = this.vue.$store.state.chat.roomMessageContainers.find((item) => item.room.id === roomId);
        if (container) {
            let localCount = container.roomMessages.filter((item) => 
                item.timestamp >= startTime
                && (item.type === CONSTANT.messageType.TEXT
                || item.type === CONSTANT.messageType.IMAGE
                || item.type === CONSTANT.messageType.EMOTION)).length;
            let diffCount = serverCount - localCount;
            if (diffCount > 0) {
                await this.vue.$store.dispatch(actionTypes.CHAT_RELOAD_HISTORY_MESSAGE, { roomId: roomId });
                this.vue.$store.commit(mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER, { roomId: roomId, count: diffCount });

                // 紀錄log
                console.log("found loss chat message, diffCount=" + diffCount)
            }
        }
    }
}

export default new ChatMessageLossDetection();